import { Component, h } from '@stencil/core';
import { defaultReview } from '@ugc-components/ugc-pdp-review/interface';
import state from '@ugc-store';
import { isRtl } from '@ugc-utils/utils';
import { modalZIndex } from '@ugc-utils/modal-z-index';

@Component({
  tag: 'ugc-review-mw-image-modal',
  styleUrl: 'ugc-review-mw-image-modal.scss',
  shadow: false,
})
export class UgcReviewMWImageModal {
  handleSwipeLeft = () => {
    this.getPrevOrNextImage('prev');
  };
  handleSwipeRight = () => {
    this.getPrevOrNextImage('next');
  };

  getImageGallaryInfo = () => {
    const {
      reviewImageModalData: { reviewItem, imageActiveIndex },
    } = state;
    if (reviewItem && reviewItem.images.length) {
      const { images } = reviewItem;
      return {
        reviewItem,
        images: {
          left: imageActiveIndex === 0 ? '' : images[imageActiveIndex - 1],
          center: images[imageActiveIndex],
          right: imageActiveIndex === images.length - 1 ? '' : images[imageActiveIndex + 1],
        },
      };
    }
    return {
      filterReviewItem: defaultReview,
      images: {
        left: '',
        center: '',
        right: '',
      },
    };
  };

  getPrevOrNextImage = async flag => {
    const {
      reviewImageModalData: { reviewItem, imageActiveIndex },
    } = state;
    if (reviewItem && reviewItem.images.length) {
      const { images } = reviewItem;
      const imageIndex = flag === 'prev' ? imageActiveIndex - 1 : imageActiveIndex + 1;
      if (imageIndex < 0 || imageIndex > images.length - 1) return;
      state.reviewImageModalData = {
        ...state.reviewImageModalData,
        imageActiveIndex: imageIndex,
      };
    }
  };

  handleCancel() {
    state.reviewImageModalData = {
      reviewItem: defaultReview,
      imageActiveIndex: 0,
    };
    state.isShowReviewImageModal = false;
  }

  render() {
    const {
      isShowReviewImageModal,
      reviewStaticLanguage: { IDS_LBL_REVIEW_IMAGES } = {},
      reviewImageModalData: { reviewItem },
    } = state;

    const { images } = this.getImageGallaryInfo();

    return (
      <ugc-drawer
        isShow={isShowReviewImageModal}
        modalTitle={IDS_LBL_REVIEW_IMAGES}
        isShowButton={false}
        zIndex={modalZIndex['ugc-review-single-image-modal']}
        handleCancel={this.handleCancel.bind(this)}
      >
        {isShowReviewImageModal && (
          <div class="ugc-review-item-mobile-modal-wrap my-16">
            <ugc-swipe handleSwipeLeft={this.handleSwipeLeft} handleSwipeRight={this.handleSwipeRight} isRTL={isRtl()}>
              <div class="review-image-wrap">
                {Object.keys(images).map(key => {
                  const item = images[key];
                  return (
                    <div class={`image-item ${key}`}>
                      {item && item.paths && item.paths.l && (
                        <img
                          key={item.assetId}
                          src={item.paths.l}
                          style={{ height: '327px' }}
                          alt="image"
                          class="border-1 border-solid border-gray-300 rounded-4 pointer"
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            </ugc-swipe>

            {/* review */}
            <div class="m-8 p-16">
              <ugc-review-item reviewItem={reviewItem} isModal={true} />
            </div>
          </div>
        )}
      </ugc-drawer>
    );
  }
}
